import dayjs from 'dayjs';
import type { PolicyDetailsDTO, PolicyExtractionDTO } from '../../../infrastructure/models';

export const POLICY_FAILURE_REPORT_RECIPIENT = 'admin@rubix.com';
export const POLICY_FAILURE_REPORT_SUBJECT = 'Policy Failure Details';

export type PolicyFailureReportOptions = {
  source: PolicyExtractionDTO | PolicyDetailsDTO;
  details?: PolicyDetailsDTO | null;
  policy?: PolicyExtractionDTO | null;
  tenantId?: string;
  recipient?: string;
  subject?: string;
};

export const openPolicyFailureReportMail = ({
  source,
  details,
  policy,
  tenantId,
  recipient = POLICY_FAILURE_REPORT_RECIPIENT,
  subject = POLICY_FAILURE_REPORT_SUBJECT,
}: PolicyFailureReportOptions) => {
  const tenantIdentifier = tenantId ?? policy?.tenantId ?? source.tenantId ?? 'N/A';
  const policyIdentifier = policy?.id ?? source.id ?? 'N/A';
  const lines: string[] = [
    '_Please enter your comments here_',
    '(replace this placeholder with your comments before sending)',
    '',
    '',
    'Policy Failure Details:-',
    `Tenant ID: ${tenantIdentifier}`,
    `Policy ID: ${policyIdentifier}`,
    `Location: ${source.location ?? 'N/A'}`,
    `Status: ${source.status ?? 'Unknown'}`,
    `Version: ${typeof source.version === 'number' ? source.version : 'N/A'}`,
    `Created: ${source.createdAt ? dayjs(source.createdAt).format('MMM D, YYYY h:mm A') : 'N/A'}`,
    `Updated: ${source.updatedAt ? dayjs(source.updatedAt).format('MMM D, YYYY h:mm A') : 'N/A'}`,
    `Created By: ${source.userId ?? 'N/A'}`,
  ];

  const fileList = details?.files?.length ? details.files : undefined;
  const errorList = details?.errors?.length ? details.errors : undefined;

  if (fileList) {
    lines.push('', 'Source Files:-');
    fileList.forEach((file) => {
      lines.push(`- ${file}`);
    });
  }

  if (errorList) {
    lines.push('', 'Errors:');
    errorList.forEach((error) => {
      lines.push(`- ${error}`);
    });
  }

  const body = lines.join('\n');
  const mailto = `mailto:${encodeURIComponent(recipient)}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  window.location.assign(mailto);
};
